import { REHYDRATE } from 'redux-persist';
import {
  USER_ACTIVITY_FETCH,
  USER_ACTIVITY_FETCH_BY_ID,
  USER_ACTIVITY_SET_FILTERS,
} from '../actions';

const INIT_STATE = {
  list: [],
  list_paging: { total_rows: 0, page_size: 25, page_indx: 0 },
  activity: null,
  notes: [],
  mail: [],
  mail_thread: [],
  mail_templates: [],
  call_history: [],
  timeline: [],
  org_filters: { parents: [], orgs: [] },
  grid_options: {
    activity: {
      crud_modal: null,
      crud_data: null,
      view: 'list',
      sort: 'asc',
      search: null,
      filters: {
      }
    }
  },
};

const handler = (state = INIT_STATE, action) => {
  switch (action.type) {
    case USER_ACTIVITY_FETCH.SUCCESS:
    case USER_ACTIVITY_FETCH_BY_ID.SUCCESS: {
      const { activity, total_rows, page_size, page_indx } = action.payload
      return { ...state, list: activity, list_paging: { total_rows, page_size, page_indx } }
    }
    // case USER_ACTIVITY_FETCH_BY_ID.SUCCESS: {
      // return { ...state, activity: action.payload }
    // }
    case USER_ACTIVITY_SET_FILTERS.REQUEST: {
      return { ...state, grid_options: {
        ...state.grid_options,
        activity: {
          ...state.grid_options.activity,
          filters: {
            ...state.grid_options.activity.filters,
            ...action.payload,
          }
        },
      } }
    }
    case REHYDRATE: {
      return INIT_STATE
    }
    default: return { ...state };
  }
}

export default handler
